// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 仪表板整体布局优化 */
.enhanced-dashboard {
  padding: 12px !important;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 欢迎卡片优化 */
.welcome-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  margin-bottom: 12px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15) !important;
}

.welcome-card .ant-card-body {
  padding: 16px 20px !important;
}

/* 统计卡片优化 */
.stats-card {
  transition: all 0.3s ease;
  height: 100%;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.1) !important;
}

.stats-card .ant-card-body {
  padding: 16px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 内容卡片优化 */
.content-card {
  border-radius: 8px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
  height: 100%;
}

.content-card .ant-card-body {
  padding: 16px !important;
}

.content-card .ant-card-head {
  padding: 0 16px !important;
  min-height: 48px !important;
}

/* 列表项优化 */
.order-list-item {
  padding: 12px 0 !important;
  border-bottom: 1px solid #f0f0f0;
}

.order-list-item:last-child {
  border-bottom: none;
}

/* 右侧面板优化 */
.side-panel {
  height: 100%;
}

.side-panel .ant-space-item {
  width: 100%;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .enhanced-dashboard {
    padding: 8px !important;
  }
  
  .welcome-card .ant-card-body {
    padding: 12px 16px !important;
  }
  
  .stats-card .ant-card-body {
    padding: 12px !important;
  }
  
  .content-card .ant-card-body {
    padding: 12px !important;
  }
}

/* 紧凑模式 */
.compact-mode {
  padding: 8px !important;
}

.compact-mode .welcome-card {
  margin-bottom: 8px !important;
}

.compact-mode .welcome-card .ant-card-body {
  padding: 12px 16px !important;
}

.compact-mode .stats-card .ant-card-body {
  padding: 12px !important;
}

.compact-mode .content-card .ant-card-body {
  padding: 12px !important;
}

/* 统计数字优化 */
.ant-statistic-content {
  font-weight: 600;
}

.ant-statistic-title {
  font-size: 13px !important;
  margin-bottom: 4px !important;
}

/* 趋势指示器 */
.trend-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  margin-top: 4px;
}

.trend-up {
  color: #52c41a;
}

.trend-down {
  color: #ff4d4f;
}

.trend-neutral {
  color: #666;
}

/* 卡片标题图标 */
.card-title-icon {
  margin-right: 6px;
  font-size: 16px;
}

/* 快速操作按钮 */
.quick-action-btn {
  width: 100%;
  height: 36px;
  border-radius: 6px;
  font-size: 13px;
}

/* 列表优化 */
.ant-list-item {
  padding: 8px 0 !important;
}

.ant-list-item-meta-title {
  font-size: 14px !important;
  margin-bottom: 2px !important;
}

.ant-list-item-meta-description {
  font-size: 12px !important;
}

/* 空状态优化 */
.ant-empty {
  padding: 20px 0 !important;
}

.ant-empty-description {
  font-size: 13px !important;
  color: #999 !important;
}

/* 加载状态优化 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

/* 标签优化 */
.status-tag {
  font-size: 11px !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
}

/* 按钮优化 */
.ant-btn-sm {
  height: 28px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
}

/* 头像优化 */
.user-avatar {
  border: 2px solid rgba(255,255,255,0.3);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 渐变背景优化 - 现代浅绿色系 */
.gradient-bg-1 { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.gradient-bg-2 { background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%); }
.gradient-bg-3 { background: linear-gradient(135deg, #6ee7b7 0%, #34d399 100%); }
.gradient-bg-4 { background: linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%); }

/* 滚动条优化 */
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
`, "",{"version":3,"sources":["webpack://./src/components/EnhancedDashboard.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,wEAAwE;EACxE,8BAA8B;EAC9B,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,SAAS;AACT;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,SAAS;AACT;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB,iBAAiB,6DAA6D,EAAE;AAChF,iBAAiB,6DAA6D,EAAE;AAChF,iBAAiB,6DAA6D,EAAE;AAChF,iBAAiB,6DAA6D,EAAE;;AAEhF,UAAU;AACV;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* 仪表板整体布局优化 */\n.enhanced-dashboard {\n  padding: 12px !important;\n  background: #f5f7fa;\n  min-height: 100vh;\n}\n\n/* 欢迎卡片优化 */\n.welcome-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  margin-bottom: 12px !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15) !important;\n}\n\n.welcome-card .ant-card-body {\n  padding: 16px 20px !important;\n}\n\n/* 统计卡片优化 */\n.stats-card {\n  transition: all 0.3s ease;\n  height: 100%;\n  border-radius: 8px !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;\n}\n\n.stats-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0,0,0,0.1) !important;\n}\n\n.stats-card .ant-card-body {\n  padding: 16px !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* 内容卡片优化 */\n.content-card {\n  border-radius: 8px !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;\n  height: 100%;\n}\n\n.content-card .ant-card-body {\n  padding: 16px !important;\n}\n\n.content-card .ant-card-head {\n  padding: 0 16px !important;\n  min-height: 48px !important;\n}\n\n/* 列表项优化 */\n.order-list-item {\n  padding: 12px 0 !important;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.order-list-item:last-child {\n  border-bottom: none;\n}\n\n/* 右侧面板优化 */\n.side-panel {\n  height: 100%;\n}\n\n.side-panel .ant-space-item {\n  width: 100%;\n}\n\n/* 响应式优化 */\n@media (max-width: 768px) {\n  .enhanced-dashboard {\n    padding: 8px !important;\n  }\n  \n  .welcome-card .ant-card-body {\n    padding: 12px 16px !important;\n  }\n  \n  .stats-card .ant-card-body {\n    padding: 12px !important;\n  }\n  \n  .content-card .ant-card-body {\n    padding: 12px !important;\n  }\n}\n\n/* 紧凑模式 */\n.compact-mode {\n  padding: 8px !important;\n}\n\n.compact-mode .welcome-card {\n  margin-bottom: 8px !important;\n}\n\n.compact-mode .welcome-card .ant-card-body {\n  padding: 12px 16px !important;\n}\n\n.compact-mode .stats-card .ant-card-body {\n  padding: 12px !important;\n}\n\n.compact-mode .content-card .ant-card-body {\n  padding: 12px !important;\n}\n\n/* 统计数字优化 */\n.ant-statistic-content {\n  font-weight: 600;\n}\n\n.ant-statistic-title {\n  font-size: 13px !important;\n  margin-bottom: 4px !important;\n}\n\n/* 趋势指示器 */\n.trend-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.trend-up {\n  color: #52c41a;\n}\n\n.trend-down {\n  color: #ff4d4f;\n}\n\n.trend-neutral {\n  color: #666;\n}\n\n/* 卡片标题图标 */\n.card-title-icon {\n  margin-right: 6px;\n  font-size: 16px;\n}\n\n/* 快速操作按钮 */\n.quick-action-btn {\n  width: 100%;\n  height: 36px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n/* 列表优化 */\n.ant-list-item {\n  padding: 8px 0 !important;\n}\n\n.ant-list-item-meta-title {\n  font-size: 14px !important;\n  margin-bottom: 2px !important;\n}\n\n.ant-list-item-meta-description {\n  font-size: 12px !important;\n}\n\n/* 空状态优化 */\n.ant-empty {\n  padding: 20px 0 !important;\n}\n\n.ant-empty-description {\n  font-size: 13px !important;\n  color: #999 !important;\n}\n\n/* 加载状态优化 */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n/* 标签优化 */\n.status-tag {\n  font-size: 11px !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n}\n\n/* 按钮优化 */\n.ant-btn-sm {\n  height: 28px !important;\n  padding: 0 12px !important;\n  font-size: 12px !important;\n}\n\n/* 头像优化 */\n.user-avatar {\n  border: 2px solid rgba(255,255,255,0.3);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n/* 渐变背景优化 - 现代浅绿色系 */\n.gradient-bg-1 { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }\n.gradient-bg-2 { background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%); }\n.gradient-bg-3 { background: linear-gradient(135deg, #6ee7b7 0%, #34d399 100%); }\n.gradient-bg-4 { background: linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%); }\n\n/* 滚动条优化 */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 2px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 2px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
